import dynamic from "next/dynamic"

export const blockMapping = {
  "archive/header": dynamic(() => import("@/blocks/archive/header/header")),
  "archive/view": dynamic(() => import("@/blocks/archive/view/view")),

  /**
   * Core
   */
  "core/button": dynamic(() => import("@/blocks/core/button/button")),
  "core/buttons": dynamic(() => import("@/blocks/core/buttons/buttons")),
  "core/quote": dynamic(() => import("@/blocks/core/quote/quote")),
  "core/group": dynamic(() => import("@/blocks/core/group/group")),
  "core/heading": dynamic(() => import("@/blocks/core/heading/heading")),
  "core/image": dynamic(() => import("@/blocks/core/image/image")),
  "core/list": dynamic(() => import("@/blocks/core/list/list")),
  "core/paragraph": dynamic(() => import("@/blocks/core/paragraph/paragraph")),
  "core/table": dynamic(() => import("@/blocks/core/table/table")),

  /**
   * Core Custom
   */
  "core/login-form": dynamic(() =>
    import("@/blocks/core/login-form/login-form")
  ),
  "core/password-form": dynamic(() =>
    import("@/blocks/core/password-form/password-form")
  ),

  /**
   * Theme
   */
  "theme/contacts": dynamic(() => import("@/blocks/theme/contacts/contacts")),
  "theme/accordion": dynamic(() =>
    import("@/blocks/theme/accordion/accordion")
  ),
  "theme/accordion-v2": dynamic(() =>
    import("@/blocks/theme/accordion-v2/accordion")
  ),
  "theme/accordion-item": dynamic(() =>
    import("@/blocks/theme/accordion-v2/item")
  ),
  "theme/columns-image-cards": dynamic(() =>
    import("@/blocks/theme/columns-image-cards/columns-image-cards")
  ),
  "theme/image-card": dynamic(() =>
    import("@/blocks/theme/columns-image-cards/image-card")
  ),
  "theme/columns-text-cards": dynamic(() =>
    import("@/blocks/theme/columns-text-cards/columns-text-cards")
  ),
  "theme/text-card": dynamic(() =>
    import("@/blocks/theme/columns-text-cards/text-card")
  ),
  "theme/content-block": dynamic(() =>
    import("@/blocks/theme/content-block/content-block")
  ),
  "theme/content-blocks": dynamic(() =>
    import("@/blocks/theme/content-blocks/content-blocks")
  ),
  "theme/cookie-declaration": dynamic(() =>
    import("@/blocks/theme/cookie-declaration/cookie-declaration")
  ),
  "theme/files": dynamic(() => import("@/blocks/theme/files/files")),
  "theme/file": dynamic(() => import("@/blocks/theme/files/file")),
  "theme/featured-article": dynamic(() =>
    import("@/blocks/theme/featured-article/featured-article")
  ),
  "theme/hero": dynamic(() => import("@/blocks/theme/hero/hero")),
  "theme/blurbs": dynamic(() => import("@/blocks/theme/blurbs/blurbs")),
  "theme/blurb": dynamic(() => import("@/blocks/theme/blurbs/blurb")),
  "theme/article-teasers": dynamic(() =>
    import("@/blocks/theme/article-teasers/article-teasers")
  ),
  "theme/link-list": dynamic(() =>
    import("@/blocks/theme/link-list/link-list")
  ),
  "theme/link": dynamic(() => import("@/blocks/theme/link/link")),
  "theme/latest-articles": dynamic(() =>
    import("@/blocks/theme/latest-articles/latest-articles")
  ),
  "theme/image": dynamic(() => import("@/blocks/theme/image/image")),
  "theme/image-and-text": dynamic(() =>
    import("@/blocks/theme/image-and-text/image-and-text")
  ),
  "theme/image-slider": dynamic(() =>
    import("@/blocks/theme/image-slider/image-slider")
  ),
  "theme/youtube": dynamic(() => import("@/blocks/theme/youtube/youtube")),
  "theme/video-teasers": dynamic(() =>
    import("@/blocks/theme/video-teasers/video-teasers")
  ),
  "theme/pdf-flipbook": dynamic(() =>
    import("@/blocks/theme/pdf-flipbook/pdf-flipbook")
  ),
  "theme/pdf-list": dynamic(() => import("@/blocks/theme/pdf-list/pdf-list")),
  "theme/post-slider": dynamic(() =>
    import("@/blocks/theme/post-slider/post-slider")
  ),
  "theme/personnel-catalog": dynamic(() =>
    import("@/blocks/theme/personnel-catalog/personnel-catalog")
  ),
  "theme/useragent-conditional-content": dynamic(() =>
    import(
      "@/blocks/theme/useragent-conditional-content/useragent-conditional-content"
    )
  ),
  "theme/lightbox": dynamic(() => import("@/blocks/theme/lightbox/lightbox")),
  "theme/press-via-tt": dynamic(() =>
    import("@/blocks/theme/press-via-tt/press-via-tt")
  ),
  "theme/google-maps": dynamic(() =>
    import("@/blocks/theme/google-maps/google-maps")
  ),
  "theme/spotify": dynamic(() => import("@/blocks/theme/spotify/spotify")),
  "theme/gravity-form": dynamic(() =>
    import("@/blocks/theme/gravity-form/gravity-form")
  ),
  "theme/text-block": dynamic(() =>
    import("@/blocks/theme/text-block/text-block")
  ),
  "theme/text-block-heading": dynamic(() =>
    import("@/blocks/theme/text-block/text-block-heading")
  ),
  "theme/text-block-body": dynamic(() =>
    import("@/blocks/theme/text-block/text-block-body")
  ),
  "theme/multisoft-snippet": dynamic(() =>
    import("@/blocks/theme/multisoft-snippet/multisoft-snippet")
  ),
  "theme/content-with-form": dynamic(() =>
    import("@/blocks/theme/content-with-form/content-with-form")
  ),
  "theme/form-content": dynamic(() =>
    import("@/blocks/theme/form-content/form-content")
  ),
  "theme/sound-clip": dynamic(() =>
    import("@/blocks/theme/sound-clip/sound-clip")
  ),
  "theme/icon": dynamic(() => import("@/blocks/theme/icon/icon")),
  "theme/tabbed-content-wrapper": dynamic(() =>
    import("@/blocks/theme/tabbed-content/wrapper/wrapper")
  ),
  "theme/tabbed-content-tab": dynamic(() =>
    import("@/blocks/theme/tabbed-content/tab/tab")
  ),
  "theme/article-hero": dynamic(() =>
    import("@/blocks/theme/article-hero/article-hero")
  ),
  "theme/article-tag": dynamic(() =>
    import("@/blocks/theme/article-hero/article-tag")
  ),
  "theme/article-terms": dynamic(() =>
    import("@/blocks/theme/article-hero/article-terms")
  ),
  "theme/article-meta": dynamic(() =>
    import("@/blocks/theme/article-hero/article-meta")
  ),
  "theme/article-sidebars": dynamic(() =>
    import("@/blocks/theme/article-sidebars/article-sidebars")
  ),
  "theme/article-cta": dynamic(() =>
    import("@/blocks/theme/article-cta/article-cta")
  ),
  "theme/quote-slider": dynamic(() =>
    import("@/blocks/theme/quote-slider/quote-slider")
  ),
  "theme/product-header": dynamic(() =>
    import("@/blocks/theme/product-single/product-header")
  ),
  "theme/product-info": dynamic(() =>
    import("@/blocks/theme/product-single/product-info")
  ),
  "theme/archive-ingredients": dynamic(() =>
    import("@/blocks/theme/archive-ingredients/archive-ingredients")
  ),
  "theme/latest-products": dynamic(() =>
    import("@/blocks/theme/latest-products/latest-products")
  ),
  "theme/project-single": dynamic(() =>
    import("@/blocks/theme/project-single/project-single")
  )
}
